// src/components/CategoryDetail.js

import React from 'react';
import { useParams } from 'react-router-dom';
import StockItemForm from './StockItemForm';


const CategoryDetail = () => {
    const { name: categoryName } = useParams();

    return (
        <div>
            <StockItemForm categoryName={categoryName} />
        </div>
    );
};

export default CategoryDetail;
